const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.PUBLIC, ApiDataModel.EMPLOYEE)

export const apiLogin = {
	login: async (email: string, password: string): Promise<IUserModel> => {
		const obj = { email, password }
		const { data } = await apiCommon<IUser>(`${groupPrefix}/login`, {
			method: 'POST',
			body: obj,
		})
		return User(data)
	},
}
